/* SW: Schalter fuer Zusatzprodukte in der Warenkorb-Schublade (snippets/sw-cart-addons.liquid). */
(() => {
  let busy = false;
  const failed = new Set();
  const tried = new Set(); // Voreinstellung nur einmal je Seitenaufruf, nie in Schleife

  async function update(updates, attributes) {
    if (busy) return;
    busy = true;
    const drawer = document.querySelector('cart-drawer');
    try {
      const res = await fetch(`${window.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, attributes, sections: 'cart-drawer,cart-icon-bubble' }),
      });
      if (!res.ok) throw new Error(res.status);
      const state = await res.json();
      const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
      const dom = parse(state.sections['cart-drawer']);
      for (const sel of ['cart-drawer-items', '.cart-drawer__footer']) {
        const target = document.querySelector(sel);
        const source = dom.querySelector(sel);
        if (target && source) target.innerHTML = source.innerHTML;
      }
      const bubble = document.getElementById('cart-icon-bubble');
      const bubbleSrc = parse(state.sections['cart-icon-bubble']).querySelector('.shopify-section');
      if (bubble && bubbleSrc) bubble.innerHTML = bubbleSrc.innerHTML;
      if (drawer && state.item_count === 0) drawer.classList.add('is-empty');
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sw-cart-addons', cartData: state });
      }
    } catch (e) {
      Object.keys(updates).forEach((id) => failed.add(id));
    } finally {
      busy = false;
      setTimeout(scan, 0);
    }
  }

  function scan() {
    const box = document.querySelector('cart-drawer .sw-addons');
    if (!box || busy) return;
    const auto = box.dataset.swAutoadd;
    if (auto && !failed.has(auto) && !tried.has(auto)) {
      tried.add(auto);
      update({ [auto]: 1 }, {});
      return;
    }
    const cleanup = (box.dataset.swCleanup || '').split(',').filter(Boolean);
    if (cleanup.length) {
      const updates = {};
      cleanup.forEach((id) => (updates[id] = 0));
      tried.clear();
      update(updates, {});
    }
  }

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-sw-addon]');
    if (!input) return;
    const id = input.dataset.swAddon;
    const on = input.checked;
    input.closest('.sw-addon')?.classList.toggle('is-on', on);
    const attributes = 'swAddonSp' in input.dataset ? { _sw_sp_off: on ? '' : '1' } : {};
    update({ [id]: on ? 1 : 0 }, attributes);
  });

  const start = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(() => scan()).observe(drawer, { childList: true, subtree: true });
    scan();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
